import axios from "axios";
import CAR from "../../../Images/customer/policy-car.svg";
import TWO from "../../../Images/customer/policy-bike.svg";
import Edit from "../../../Images/customer/Edit.svg";
import { showToaster } from "../../toster";
import { useState, useEffect } from "react";

const SaveData = ({ data, onEditClick }) => {
    console.log(data);

    // Initialize State with Proper Defaults
    const [Data, setData] = useState({
        ManufacturerName: "",
        ModelName: "",
        VarientName: "",
        RegAuthority: "",
        RtoCode: "",
        PolicyExpiry: "",
        PolicyNumber: "",
        PolicyType: "",
        PolicyHolder: "",
    });

    const [formData, setFormData] = useState({
        
    });
    console.log(formData, "formData")
    const PolicySyncForm = async () => {
        const token = localStorage.getItem("smc-csp-token");
        if (!token) {
            showToaster({ message: "Authentication token missing!", type: "error" });
            return;
        }

        try {
            const response = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/Api/Policies/AddOtherPolicyDetail",
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.data.StatusCode === 200) {
                showToaster({ message: response.data.ErrorMessage, type: "success" });
            } else {
                showToaster({ message: "Failed to sync policy", type: "error" });
            }
        } catch (error) {
            console.error("Error submitting policy data:", error);
            showToaster({ message: "Error syncing policy. Try again!", type: "error" });
        }
    };


    useEffect(() => {
        setFormData(data?.vahanData ? data.formattedData : data);
    }, []); // Runs whenever `data` updates

    useEffect(() => {
        setData({
            ManufacturerName: data?.vahanData ? data?.vahanData?.response?.manufacturer : data?.ManufacturerName,
            ModelName: data?.vahanData ? data?.vahanData?.response?.vehicle : data?.ModelName,
            VarientName: data?.vahanData ? data?.vahanData?.response?.variant : data?.VarientName,
            RegAuthority: data?.vahanData ? data?.vahanData?.response?.regAuthority : data?.RegionName,
            RtoCode: data?.vahanData ? data?.vahanData?.response?.rtoCode : data?.rtoCode,
            PolicyExpiry: data?.vahanData ? data?.vahanData?.response?.insuranceUpto : data?.PolicyExpiryDate,
            PolicyNumber: data?.vahanData ? data?.vahanData?.response?.insurancePolicyNumber : data?.PolicyNo,
            Insurer: data?.vahanData ? data?.vahanData?.response?.insuranceCompanyName : data?.Insurer,
            PolicyType: data?.vahanData ? data?.vahanData?.response?.vehicleType : data?.PolicyType,
            PolicyHolder: data?.vahanData ? data?.vahanData?.response?.owner : data?.CustomerName,
            VehicleNo: data?.vahanData ? data?.vahanData?.response?.regNo : data?.VehicleNo,
            VehicleNo: data?.vahanData ? data?.vahanData?.response?.regNo : data?.VehicleNo,
        });

    }, [data]);

    return (
        <>
            {data && (
                <div className="P_DataSave">
                    <div className="VehicleDetails">
                        <div className="VehicleHead">
                            <div className="VehicleLogo">
                                {data.vehicleType === "PrivateCar" && <img alt="Car" src={CAR} />}
                                {data.vehicleType === "TwoWheeler" && <img alt="Bike" src={TWO} />}
                            </div>
                            <div className="VehicleModel">
                                <h5>{Data.ManufacturerName} {Data.ModelName}</h5>
                                <p>{Data.VarientName}, {Data.RtoCode}, {Data.RegAuthority}</p>
                            </div>
                        </div>

                        <div className="VehicleOtherDetails">
                            <div className="VehicleDBox">
                                <span>Policy Number</span>
                                <p>{Data.PolicyNumber}</p>
                            </div>

                            <div className="VehicleDBox">
                                <span>Policy Expiry Date</span>
                                <p>{Data.PolicyExpiry}</p>
                            </div>

                            <div className="VehicleDBox">
                                <span>Policy Type</span>
                                <p>{Data.PolicyType}</p>
                            </div>

                            <div className="VehicleDBox">
                                <span>Policy Holder Name</span>
                                <p>{Data.PolicyHolder}</p>
                            </div>
                        </div>

                        <p className="EditBtn" onClick={onEditClick}>
                            <img src={Edit} alt="Edit" /> Edit details
                        </p>
                    </div>
                </div>
            )}

            <button className="btn-customr" onClick={PolicySyncForm}>
                Sync the Policy
            </button>
        </>
    );
};

export default SaveData;
